import { render, staticRenderFns } from "./PatientBar.vue?vue&type=template&id=44faf39a&scoped=true&"
import script from "./PatientBar.vue?vue&type=script&lang=js&"
export * from "./PatientBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44faf39a",
  null
  
)

export default component.exports